import { Component, OnInit } from '@angular/core';
import { ModelTypeRegistrationService } from './model-type-registration.service';
import { ApiResponse } from '../../models/api-response';
import { NotificationService } from "../../services/notification.service";

@Component({
    selector: "model-type-registration",
    template: require("./model-type-registration.component.html")
})
export class ModelTypeRegistrationComponent {
    private modelType: string;
    private description: string;

    constructor(private service: ModelTypeRegistrationService, private notifier: NotificationService) {
        this.notifier.clear();
    }

    addModelType() {
        
        if (this.isModelTypeInvalid()) {
            this.notifier.displayError("Model type Id is invalid");
            return;
        }
        this.notifier.displayInfo("Adding model type");
        this.service.addModelType(this.modelType, this.description)
            .subscribe(
            resp => {
                if (resp.statusCode === 201) {
                    this.notifier.displaySuccess(resp.data);

                } else {
                    this.notifier.displayError(resp.data.value);
                }
            },
            error => {
                this.notifier.displayApiResponseError(error);
            }); 
    }

    isModelTypeInvalid() {
        let regex = new RegExp("^[a-zA-Z0-9:-]{1,49}$");
        return (this.modelType === undefined
            || this.modelType.trim() === ""
            || !regex.test(this.modelType)
        );
    }
}


/** WEBPACK FOOTER **
 ** ./F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/app/main/modelTypeRegistration/model-type-registration.component.ts
 **/